import { Box } from "@material-ui/core"
import React from "react"

const FormLabel: React.FC<{ label: string }> = ({ label }) => {
    return <Box fontSize="14px" fontWeight="fontWeightBold">
        {label}
    </Box>
}

export { FormLabel };